<template>
  <v-tab-item :value="value">
    <slot />
  </v-tab-item>
</template>

<script>
export default {
  name: "TabItem",
  props: {
    value: {
      type: Number
    }
  }
}
</script>

<style scoped>

</style>